import { API } from "apis";
import { AuthInfoModel } from "models";
import React from "react";

export const useAuthInfo = () => {
  const [authInfo, setAuthInfo] = React.useState<AuthInfoModel>();

  const initialize = async () => {
    try {
      const response = await API.Auth.detail();
      console.log(response);
      setAuthInfo(response.data);
      return { data: response.data };
    } catch (err) {
      console.log(err);
      return {};
    }
  };

  return { initialize, data: authInfo };
};
